import classNames from 'classnames';
import React from 'react';
import styles from './SettingCard.module.scss';

interface SettingCardProps {
  actions?: React.ReactNode;
  description?: React.ReactNode;
  details?: React.ReactNode;
  disabled?: boolean;
  actionActive?: boolean;
  icon?: React.ReactNode;
  title?: React.ReactNode;
}

const SettingCard = ({
  actions,
  description,
  details,
  disabled = false,
  actionActive = true,
  icon,
  title,
}: SettingCardProps) => (
  <div
    className={classNames(styles.container, {
      [styles.titleOnly]: !details,
      [styles.disabled]: disabled,
      [styles.hoverToShowAction]: !actionActive,
    })}
  >
    {!!icon && <div className={styles.icon}>{icon}</div>}
    <div className={styles.content}>
      {!!title && <h5>{title}</h5>}
      {description}
      {!!details && <div className={styles.details}>{details}</div>}
    </div>
    {!!actions && <div className={styles.actions}>{actions}</div>}
  </div>
);

export default SettingCard;
